import { render } from "./DigitalAssetUpload.vue?vue&type=template&id=16616196&scoped=true&ts=true"
import script from "./DigitalAssetUpload.vue?vue&type=script&lang=ts"
export * from "./DigitalAssetUpload.vue?vue&type=script&lang=ts"

import "./DigitalAssetUpload.vue?vue&type=style&index=0&id=16616196&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16616196"]])

export default __exports__